import styled from 'styled-components';

export const ItensQuantity = styled.span`
  font-family: ${({ theme }) => theme.fonts.workSans};
`;

export const BottomContainer = styled.div<{ littleContent?: boolean }>`
  background: ${({ theme }) => theme.colors.white};

  display: flex;
  justify-content: space-between;

  padding: 1.5rem;
  gap: 1.5rem;
  min-height: 96px;

  position: sticky;
  width: -webkit-fill-available;
  bottom: 0;
  left: 0;

  z-index: 99;

  box-shadow: ${({ theme }) => theme.commoms.boxShadow2};
  @media (max-width: ${({ theme }) => theme.breakpoints.laptopM}) {
    flex-direction: column;
  }

  @media(max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    position ${({ littleContent }) => (littleContent ? 'fixed' : 'sticky')};
  }
`;

export const BottomSummary = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BottomButtons = styled.div`
  display: flex;
  gap: 1.5rem;

  .hefesto-button {
    height: 3rem;
  }

  & > button {
    width: 270px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.laptopM}) {
    justify-content: space-between;
  }
`;
